import React from 'react';
import { Button } from '../ui/button';

export function EmptyState({ icon: Icon, title, body, actionLabel, onAction, secondaryLabel, onSecondary, testId }) {
  return (
    <div className="flex flex-col items-center text-center py-12 px-4 animate-in fade-in duration-500" data-testid={testId}>
      {Icon && (
        <div className="w-16 h-16 rounded-full bg-[#F9F6F0] border border-[#E6E4DD] flex items-center justify-center mb-5">
          <Icon className="h-7 w-7 text-[#D4AF37]" />
        </div>
      )}
      <h4 className="font-heading text-lg font-medium text-[#1A1A1A] mb-2">{title}</h4>
      <p className="text-sm text-stone-500 max-w-md leading-relaxed mb-6">{body}</p>
      <div className="flex flex-wrap justify-center gap-3">
        {actionLabel && (
          <Button onClick={onAction} className="btn-primary" data-testid={`${testId}-action`}>{actionLabel}</Button>
        )}
        {secondaryLabel && (
          <Button variant="outline" onClick={onSecondary} data-testid={`${testId}-secondary`}>{secondaryLabel}</Button>
        )}
      </div>
    </div>
  );
}

export async function copyStorefrontLink(username) {
  const url = `https://zuriya.co.uk/@${username}`;
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    const ta = document.createElement('textarea');
    ta.value = url;
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  }
}
